import React from 'react';
import { useDispatch } from 'react-redux';

import { ArrowDown } from '@travel/icons/ui';
import { toSEOSearchString } from '@travel/traveler-core/utils/seo';
import { cx } from '@travel/utils';

import StyledSelectBox from 'components/StyledSelectBox';

import { pushLocation } from 'store/__router/actions';

import { SearchFormQuery } from 'ProviderList-Types';
import paths from 'core/universalRouter/paths';
import { SORT_OPTIONS } from 'constants/provider';
import useLabelSelectBoxOptions from 'hooks/useLabelSelectBoxOptions';
import { FIRST_PAGE_PARAMS } from 'pages/ProviderListPage/resolver';

import styles from './sortSelectBox.module.scss';

type Props = {
  className?: string;
  /** Current search param object */
  params: { pageIdentifier: string };
  /** Current search query object */
  query: SearchFormQuery;
};

/**
 * Currently, this component is being used on TL/PC only
 */
function SortSelectBox(props: Props) {
  const dispatch = useDispatch();
  const sortOptions = useLabelSelectBoxOptions(Object.values(SORT_OPTIONS));

  const onSelectBoxChanged = (item?: { value: string }) =>
    dispatch(
      pushLocation({
        pathname: paths.providerList.pathResolver(props.params.pageIdentifier),
        search: toSEOSearchString({ ...props.query, sortKey: item?.value, ...FIRST_PAGE_PARAMS }),
      }),
    );

  return (
    <StyledSelectBox
      name="sortSelectBox"
      className={cx(props.className, styles.wrapper)}
      listClassName={styles.popup}
      options={sortOptions}
      onChange={onSelectBoxChanged}
      dropdownIcon={<ArrowDown className={styles.displayIcon} color="cilantro" size={12} />}
      value={props.query.sortKey || SORT_OPTIONS['recommended'].value}
    />
  );
}

export default React.memo(SortSelectBox);
